export class Notification {
  public id: number;
  public message: string;
  public link: string;
  public isRead: boolean;
  public created: Date;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/notification.ts